module.exports = __webpack_public_path__ + "static/media/curtain.795b421a.svg";